import { gql } from '@adc/sdk'

// TODO: This is just a fragment so we should not need it
/* eslint-disable @adc/named-gql-operations */
export const FEATURE_FLAGS_FRAGMENT = gql`
  fragment FeatureFlags on User {
    feature_flags(
      filters: {
        flagKeys: [
          "fe.resi.enable-web-remote-bidding"
          "app.enable-pdp-design-2025"
          "fe.resi.enable-unified-pdp"
          "fe.resi.pdp.enable-property-history"
          "fe.resi.ai-assistant"
          "fe.resi.enable-live-chat-banner-in-ai-chat"
        ]
        context: $context
      }
    )
  }
`
